// utility/featureFlags.js
export async function loadFlags() {
    const baseUrl = process.env.REACT_APP_BASE_URL_CONFIG ?? '/';
    const url = `${baseUrl}Config/feature-flags.json`;
    const res = await fetch(url, { cache: 'no-store' });

    const raw = await res.text();           // <-- leggo testo grezzo
    // utile per debug --> console.log('[FF] raw flags.json:\n', raw);

    if (!res.ok) throw new Error('Impossibile caricare /Config/feature-flags.json');

    try {
        return JSON.parse(raw);               // <-- parse manuale per catturare l’errore
    } catch (e) {
        console.error('[FF] JSON parse error:', e);
        throw e;
    }
}

function norm(s) { return (s ?? '').trim().toLowerCase(); }

/**
 * Risolve un flag con precedenza: utente > ruolo > iduser > globale > default
 * - flags: oggetto flags già caricato
 * - key:   nome del flag
 * - ctx:   { username, roles, iduser }
 * - def:   default da usare se non trovato
 */
export function resolveFlagFrom(flags, key, { username, roles = [], iduser = null } = {}, def = false) {
    const f = flags || {};
    const uname = norm(username)
    const uid = iduser ? `@id_${norm(iduser)}` : null;
    const rset = (roles || []).map(r => `@role_${norm(r)}`);

    const tried = [];
    if (uname) tried.push(`${key}_@${uname}`);
    if (uid) tried.push(`${key}_${uid}`);
    rset.forEach(r => tried.push(`${key}_${r}`));
    tried.push(key);

    // LOG: cosa stiamo tentando
    // utile per debug --> console.log('[FF] resolve try order:', tried);

    // 1) per-utente (email completa)
    if (uname && Object.hasOwn(f, `${key}_@${uname}`)) return f[`${key}_@${uname}`];

    // 2) per-id utente (GUID)
    if (uid && Object.hasOwn(f, `${key}_${uid}`)) return f[`${key}_${uid}`];

    // 3) per-ruolo
    for (const r of rset) {
        const k = `${key}_${r}`;
        if (Object.hasOwn(f, k)) return f[k];
    }

    // 4) globale
    if (Object.hasOwn(f, key)) return f[key];

    return def;
}